module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/BW/soccer-43b25c4f1e0df51f77132db888b64972.svg";